import Switch from "@mui/material/Switch";
import { useSelector } from "react-redux";

type SwitchToggleProps = {
  checked: boolean;
  setChecked: (isActive: boolean, e?: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
};
const SwitchToggle = ({ checked, setChecked, isDisabled }: SwitchToggleProps) => {
  const isDarkMode = useSelector((state: { theme }) => state.theme.darkMode);

  return (
    <Switch
      checked={checked}
      onChange={e => setChecked(e.target.checked)}
      edge="start"
      disabled={isDisabled}
      sx={{
        "& .MuiSwitch-thumb": {
          color: isDarkMode ? "rgba(224, 224, 224)" : "rgba(250, 250, 250)",
        },
        "& .MuiSwitch-track": {
          backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.38)" : "rgba(0, 0, 0, 1)",
        },
        "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
          color: "var(--success-main)",
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: "var(--success-main)",
        },
      }}
    />
  );
};

export default SwitchToggle;
